// Components==============
import React, { useEffect } from 'react';
import CardVideo from 'components/UI/Card/components/Video';
import ColoredButton from '../ColoredButton';
import { DownloadButton } from '../DownloadButton';
import NormalButton from '../NormalButton';
import './index.module.scss';
// =========================

const Image = ({ item }) => (
    <img styleName="image" src={`/storage/${item}`} alt="item" />
);
const ImageDouble = ({ itemLeft, itemRight }) => (
    <div styleName="double-image">
        <div styleName="wrapper">
            <img src={`/storage/${itemLeft}`} alt="item" />
        </div>
        <div styleName="wrapper">
            <img src={`/storage/${itemRight}`} alt="item" />
        </div>
    </div>
);
const Text = ({ item, page }) => (
    <div
        dangerouslySetInnerHTML={{ __html: item }}
        styleName={`richText ${page ? 'page' : 'popup'}`}
    />
);

const ButtonRowColored = ({ item }) => (
    <div styleName="button-row">
        {item.content?.map((e, i) => (
            <ColoredButton
                index={i}
                key={i}
                text={e.attributes?.text}
                popup={e.attributes?.popup}
            />
        ))}
    </div>
);

const ButtonRowNormal = ({ item, accent, hideButtons }) => (
    <div styleName="button-row-normal">
        {item.buttons?.map((e, i) => (
            <NormalButton
                accentColor={accent}
                key={i}
                hide={hideButtons}
                text={e.attributes?.title}
                to={e.attributes?.link}
                type={e.attributes?.type}
                file={e.attributes?.file}
                popupAccent={e.attributes?.popup_accent}
                popup={e.attributes?.popup}
            />
        ))}
    </div>
);
const Title = ({ item, accent, page }) => (
    <h3
        style={{ color: accent || null }}
        styleName={`title ${page ? 'page' : 'popup'}`}
    >
        {item}
    </h3>
);
const Video = ({ item }) => (
    <>
        {item.video_type && (
            <div
                style={
                    item.video_type === 'vimeo'
                        ? { paddingBottom: '56%' }
                        : null
                }
                styleName="aspect-r"
            >
                {item.video_type === 'youtube' && (
                    <iframe
                        style={{ width: '100%', height: '100%' }}
                        src={`https://www.youtube.com/embed/${item.video_id}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="youtube"
                    />
                )}
                {item.video_type === 'vimeo' && (
                    <iframe
                        src={`https://player.vimeo.com/video/${item.video_id}`}
                        style={{ width: '100%', height: '100%' }}
                        frameBorder="0"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                        title="vimeo"
                    />
                )}
            </div>
        )}
    </>
);

export const Code = ({ item }) => {
    console.log('test');

    useEffect(() => {
        const iframes = document.getElementsByTagName('iframe');
        if (!iframes.length) {
            return;
        }
        const iframe = iframes[0];
        iframe.width = '100%';
    }, []);

    return (
        <>
            <div
                styleName="code"
                dangerouslySetInnerHTML={{ __html: item.code }}
            />
        </>
    );
};

export default function RichText({ richText, accent, page, slug }) {
    if (richText.find((item) => item.layout === 'code')) {
        imageMapResize();
    }

    return richText?.map((e, i) => {
        const { layout, attributes } = e;

        const mutatedText = attributes?.text?.replace(
            /<a /g,
            '<a target="_blank" rel="noreferrer" '
        );

        if (layout === 'image') {
            return <Image key={i} item={attributes.image} />;
        }
        if (layout === 'image_double') {
            return (
                <ImageDouble
                    key={i}
                    itemLeft={attributes.image_left}
                    itemRight={attributes.image_right}
                />
            );
        }
        if (layout === 'text') {
            return <Text page={page} key={i} item={mutatedText} />;
        }
        if (layout === 'title') {
            return (
                <Title
                    page={page}
                    accent={accent}
                    key={i}
                    item={attributes.title}
                />
            );
        }
        if (layout === 'video') {
            return <Video item={attributes} key={i} />;
        }

        if (layout === 'video_gallery') {
            return (
                <div styleName="video-wrapper">
                    <div styleName="inner">
                        {attributes.content.map((video, index) => (
                            <CardVideo
                                video={video.attributes.video_id}
                                key={index}
                                videoType={video.attributes.video_type}
                            />
                        ))}
                    </div>
                </div>
            );
        }

        if (layout === 'file') {
            return (
                <DownloadButton
                    file={`/storage/${attributes?.file}`}
                    key={i}
                    text={attributes?.file}
                />
            );
        }
        if (layout === 'button_row') {
            return <ButtonRowColored item={attributes} />;
        }

        if (layout === 'button_row_normal') {
            return (
                <ButtonRowNormal
                    hideButtons={slug === 'routekaart'}
                    accent={accent}
                    item={attributes}
                />
            );
        }

        if (layout === 'code') {
            return <Code item={attributes} />;
        }

        return <React.Fragment key={i} />;
    });
}
